import { createContext } from 'react';

const PathAccountContext = createContext<string>('');
export {
  PathAccountContext
};
